import { Component, Input } from '@angular/core';
import { ProductScore } from '@legacy/common-ui-models';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'wl-generic-rating[rating]',
  templateUrl: './generic-rating.component.html',
  styleUrls: [
    './generic-rating.component.essent.scss',
    './generic-rating.component.ed.scss',
  ],
  standalone: true,
  imports: [FaIconComponent],
})
export class GenericRatingComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rating!: ProductScore;

  get filledCircles() {
    return Array.from({ length: this.rating.outOf5 }, (_, i) => i + 1);
  }

  get emptyCircles() {
    return Array.from({ length: 5 - this.rating.outOf5 }, (_, i) => i + 1);
  }
}
